import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { HelmetProvider } from "react-helmet-async";
import Portfolio from "./pages/Portfolio";
import CaseDetail from "./pages/CaseDetail";
import { LanguageProvider } from "./context/LanguageContext";

function App() {
    return (
        <div className="App">
            <HelmetProvider>
                <LanguageProvider>
                    <BrowserRouter>
                        <Routes>
                            <Route path="/" element={<Portfolio />} />
                            <Route path="/cases/:slug" element={<CaseDetail />} />
                        </Routes>
                    </BrowserRouter>
                    <Toaster
                        position="bottom-center"
                        toastOptions={{
                            style: {
                                background: "#1a1a1a",
                                color: "#faf5ec",
                                border: "1px solid #2b2620",
                                fontFamily: "Manrope, sans-serif",
                                letterSpacing: "0.02em",
                            },
                        }}
                    />
                </LanguageProvider>
            </HelmetProvider>
        </div>
    );
}

export default App;
